import { render, staticRenderFns } from "./DaoRu.vue?vue&type=template&id=0a9dfa70&scoped=true&"
import script from "./DaoRu.vue?vue&type=script&lang=js&"
export * from "./DaoRu.vue?vue&type=script&lang=js&"
import style0 from "./DaoRu.vue?vue&type=style&index=0&id=0a9dfa70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9dfa70",
  null
  
)

export default component.exports